import React, { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
// Using lazy loading for the Toolbox component
const Toolbox = lazy(() => import("../Components/Toolbox/Toolbox"));

export default function ToolboxPage() {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    
    const schemaOrgWebPage = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "ontheweb.agency Toolbox",
        "description": "Comprehensive collection of web design and development tools. Enhance your workflow with our curated resources for creating stunning websites.",
        "url": "https://ontheweb.agency/toolbox",
        "isPartOf": {
            "@type": "WebSite",
            "name": "ontheweb.agency",
            "url": "https://ontheweb.agency/"
        }
    };

    return (
        <>
            <Helmet>
                <html lang={currentLang} />
                <title>OnTheWeb Resources Hub | Web Development & Design Tools</title>
                <meta name="description" content="Our curated collection of web design and development tools to enhance your workflow. Find resources for coding, design, productivity and technical SEO." />
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="ontheweb.agency" />
                <meta name="keywords" content="web design tools, development resources, AI tools, illustrations, color palettes, code generators" />
                
                {/* Single canonical URL - site uses browser detection for language */}
                <link rel="canonical" href="https://ontheweb.agency/toolbox" />
                
                <meta property="og:title" content="Web Development & Design Tools | OnTheWeb Resource Hub" />
                <meta property="og:description" content="Our curated collection of web design and development tools to enhance your workflow. Find resources for coding, design, productivity and technical SEO." />
                <meta property="og:url" content="https://ontheweb.agency/toolbox" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://ontheweb.agency/share-image.jpg" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="900" />
                <meta property="og:image:type" content="image/jpeg" />
                <meta property="og:image:alt" content="ontheweb.agency Toolbox - Web Design and Development Resources" />
                <meta property="og:site_name" content="ontheweb.agency" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@onthewebagency" />
                <meta name="twitter:title" content="Web Development & Design Tools | OnTheWeb Resource Hub" />
                <meta name="twitter:description" content="Our curated collection of web design and development tools to enhance your workflow. Find resources for coding, design, productivity and technical SEO." />
                <meta name="twitter:image" content="https://ontheweb.agency/share-image.jpg" />
                
                <script type="application/ld+json">
                    {JSON.stringify(schemaOrgWebPage)}
                </script>
            </Helmet>
            <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}></div>}>
                <Toolbox />
            </Suspense>
        </>
    );
}